<template>
  <v-tooltip v-if="tooltip" bottom>
    <template v-slot:activator="{ on }">
      <v-chip
        small
        :color="resolvedColor"
        :text-color="resolvedTextColor"
        class="mr-1 mb-1"
        v-on="on"
      >
        <v-icon small class="mr-1">{{ resolvedIcon }}</v-icon>
        <span>{{ label }}</span>
      </v-chip>
    </template>
    <span>{{ tooltip }}</span>
  </v-tooltip>

  <v-chip
    v-else
    small
    :color="resolvedColor"
    :text-color="resolvedTextColor"
    class="mr-1 mb-1"
  >
    <v-icon small class="mr-1">{{ resolvedIcon }}</v-icon>
    <span>{{ label }}</span>
  </v-chip>
</template>

<script>
import { statusColor, statusIcon } from './status-mapping'

export default {
  name: 'diagnostics-status-chip',
  props: {
    status: {
      type: String,
      default: 'unknown'
    },
    label: {
      type: String,
      required: true
    },
    tooltip: {
      type: String,
      default: ''
    }
  },
  computed: {
    resolvedColor () {
      return statusColor(this.status)
    },
    resolvedIcon () {
      return statusIcon(this.status)
    },
    resolvedTextColor () {
      const color = this.resolvedColor
      return color === 'warning' ? '#000' : '#fff'
    }
  }
}
</script>
